/* eslint-disable */
export const NORWEGIAN_MOBILE_NUMBER_PATTERN = /^([4,9,6,7](\d{7}|\d{6})|5\d{11})$/
export const SWEDISH_MOBILE_NUMBER_PATTERN = /^(0?7([0-3,6,9])-?(\d{11}|\d{7}))$/
export const SWEDISH_MOBILE_NUMBER_PATTERN_NO_DASH = /^(0?7([0-3,6,9])(\d{11}|\d{7}))$/

// @ts-ignore
export const getNormalizedPhoneNumber = phoneNumber => {
  if (phoneNumber.match(SWEDISH_MOBILE_NUMBER_PATTERN_NO_DASH)) {
    if (phoneNumber.substring(0, 1) !== 0) phoneNumber = '0' + phoneNumber
    return phoneNumber.substring(0, 3) + '-' + phoneNumber.substring(3, phoneNumber.length)
  }
  return phoneNumber
}
